export default "__VITE_ASSET__BaNPPliF__"